import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carousel"
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 }
  }

  connect() {
    // Wait for Bootstrap carousel plugin to be available
    this.waitForCarousel(() => {
      this.initializeCarousel()
    })
  }

  waitForCarousel(callback) {
    if (window.$.fn.carousel) {
      callback()
    } else {
      setTimeout(() => this.waitForCarousel(callback), 50)
    }
  }

  initializeCarousel() {
    const $element = window.$(this.element)
    $element.carousel({
      interval: this.intervalValue
    })
    $element.carousel("cycle")
  }
}
